import type { NotificationItem, User } from "./types";

export const emailPushSubjects = [
  { value: "governance_votes", label: "Votes and voting deadlines" },
  { value: "proposals", label: "New proposals" },
  { value: "network_actions", label: "Adopted network actions" },
  { value: "meetings_events", label: "Meetings and events" },
  { value: "member_input_requests", label: "Member input requests" },
] as const;

export type EmailPushSubject = (typeof emailPushSubjects)[number]["value"];

export const defaultEmailPushSubscriptions: EmailPushSubject[] = emailPushSubjects.map((subject) => subject.value);

const notificationSubjectMap: Record<string, EmailPushSubject | undefined> = {
  "vote required": "governance_votes",
  "vote opened": "governance_votes",
  "vote scheduled": "governance_votes",
  "proposal submitted": "proposals",
  "proposal called for vote": "governance_votes",
  "network action adopted": "network_actions",
  "meeting called": "meetings_events",
  "event published": "meetings_events",
  "view requested": "member_input_requests",
};

export function emailPushSubjectForNotificationType(type: string): EmailPushSubject | null {
  return notificationSubjectMap[type.toLowerCase()] ?? null;
}

export function isEmailPushAllowedForNotification(type: string) {
  return emailPushSubjectForNotificationType(type) !== null;
}

export function memberWantsEmailPush(user: Pick<User, "active" | "emailPushSubscriptions">, notificationType: NotificationItem["type"] | string) {
  const subject = emailPushSubjectForNotificationType(notificationType);
  if (!user.active || !subject) return false;
  const subscriptions = user.emailPushSubscriptions ?? defaultEmailPushSubscriptions;
  return subscriptions.includes(subject);
}
